import * as _ from "lodash";
import {Point} from "./Point"

/**
 * 
 * 
 **/
export function MakeAssetsMenu(assets : Object) : String
{
    var menu_assets_content = {}
    return "AAAAAA"
}






const example_floor_attachments = {
    "ecdda70f-35b3-4455-94e6-02cebe223e4b": {
        id_floor: 81081, 
        id_attachment: "ecdda70f-35b3-4455-94e6-02cebe223e4a", 
        url: "https://...",
        raw:{},
        raw_coords: [0,0],
        raw_geo_ref: [[0,0],[0,0]],
    },
    "ecdda70f-35b3-4455-94e6-02cebe223e4c": {}
}

/**
 * Takes attachments and returns a menu content object for the given floor
 * id_location : the id_location to get assets for
 * data_attachments : {id_location:{id_attachment_1:{}, id_attachment_2:{}}}
 * returns a simple object contining the number of attachments: { count: 123 }
 */
export function build_menu_content(floor_attachments: any)
{
    var attachment_count = 0
    if (floor_attachments !== undefined) {
        if (floor_attachments !== null) {
            attachment_count  = _.keys(floor_attachments).length
        }
    }
                
    return { count: attachment_count };


}



// WEBPACK FOOTER //
// ./src/ts/menu_data.ts